import { boolean, object, string } from "yup";

import { ENTITY_TAX_INFORMATION_DEFAULT_VALUES } from "@/features/entity-tax-information";

export const DEFAULT_VALUES = {
  type: "",
  ...ENTITY_TAX_INFORMATION_DEFAULT_VALUES,
  accountingActionChartOfAccounts: {},
};

export const VALIDATION_SCHEMA = object().shape({
  name: string().required("Harus diisi"),
  code: string().required("Harus diisi"),
  supplierCategory: object().required("Harus diisi"),
  type: string().required("Harus diisi"),
  email: string().nullable().email("Email tidak valid"),
  website: string().nullable().url("Website tidak valid"),
  defaultTaxIncluded: boolean().required("Harus diisi"),
  defaultPaymentTerm: object().required("Harus diisi"),
});
